import { defineMessages } from 'react-intl-next';

export default defineMessages({
	fileCloseIconLabel: {
		id: 'ai-mate.chat-input.file-close-icon-label',
		defaultMessage: 'Remove file',
		description: 'Label for the remove file icon',
	},
	fileErrorIconLabel: {
		id: 'ai-mate.chat-input.file-error-icon-label',
		defaultMessage: 'Error loading file',
		description: 'Label for the error icon',
	},
	textLoadFailed: {
		id: 'ai-mate.chat-input.text-load-failed',
		defaultMessage: 'Failed to load file content',
		description: 'Fallback message shown when reading a text file fails',
	},
	textFileTooLarge: {
		id: 'ai-mate.chat-input.text-file-too-large',
		defaultMessage: 'This file is too large to preview ({sizeMB}MB).',
		description:
			'Message shown when text file exceeds the maximum preview size. {sizeMB} is the file size in megabytes.',
	},
} as const);
